import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/workplace-xg/workplace-xg/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import ImageCollection from "../../../components/ImageCollection";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const Column = makeShortcode("Column");
const Caption = makeShortcode("Caption");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <PageDescription mdxType="PageDescription">
      <p>{`A sense of dynamism, energy and movement can be captured through the combination of different types of lighting. Lighting can also help guide users to specific behaviors. Whenever possible, use natural lighting to convey warmth and a connection to nature.`}</p>
    </PageDescription>
    <AnchorLinks mdxType="AnchorLinks">
  <AnchorLink mdxType="AnchorLink">Fixtures</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Zone lighting</AnchorLink>
    </AnchorLinks>
    <h2>{`Fixtures`}</h2>
    <p>{`Fixtures should be simple in shape and detailing to convey a contemporary, modern aesthetic. All fixtures should be lensed to produce a soft, diffused light and glow. For color temperature, choose LED lights in a warm white; 3500K is recommended.`}</p>
    <p>{`Use a neutral palette of white, gray and silver. Avoid using accent colors in lighting fixtures.`}</p>
    <ImageCollection mdxType="ImageCollection">
      <Column colLg={4} colMd={3} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGQABAAMBAQAAAAAAAAAAAAAAAAEDBAIF/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAH/2gAMAwEAAhADEAAAAaY0WGdcTy5F6B//xAAbEAEBAAIDAQAAAAAAAAAAAAABAgAEEBEUEv/aAAgBAQABBQLz1156MZrKv5Z2pF2RR7OP/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPwEf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPwEf/8QAHBAAAQMFAAAAAAAAAAAAAAAAABEhMQEQEjJB/9oACAEBAAY/Amk6a1FyJViB7//EAB0QAAMAAgMBAQAAAAAAAAAAAAABESExQWFxUbH/2gAIAQEAAT8hk+vo5674FXP1F42dZgiXhDq7HUh5+C3deFP/2gAMAwEAAgADAAAAECAXAP/EABkRAAIDAQAAAAAAAAAAAAAAAAABEBEhMf/aAAgBAwEBPxDS2Lkf/8QAGBEAAgMAAAAAAAAAAAAAAAAAAAEQESH/2gAIAQIBAT8QwpDj/8QAHhABAQACAgIDAAAAAAAAAAAAAREAITFBYXGRsdH/2gAIAQEAAT8QGlIRTWaTXe95TGKiUtfnvBTMAAoA8BoxUit0K9i4gLaSkbTf3hgi8S/mQUoeRkCAbdJg3nef/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "linear pendants",
            "title": "linear pendants",
            "src": "/workplace-xg/static/0621f4ad1f4b83bc1e7a58dde78b5e0e/473e3/linear-pendants.jpg",
            "srcSet": ["/workplace-xg/static/0621f4ad1f4b83bc1e7a58dde78b5e0e/69549/linear-pendants.jpg 288w", "/workplace-xg/static/0621f4ad1f4b83bc1e7a58dde78b5e0e/473e3/linear-pendants.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
      <Column colLg={8} colMd={5} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAGAAAAgMAAAAAAAAAAAAAAAAAAAUBAwT/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAf/aAAwDAQACEAMQAAAB1yqrhuLCv//EABkQAAIDAQAAAAAAAAAAAAAAAAABAhESIv/aAAgBAQABBQJUaLHJxNI7Z//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8BP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8BP//EABwQAAEEAwEAAAAAAAAAAAAAAAACESExARASQf/aAAgBAQAGPwK9enTwQpWS2P/EABwQAQACAgMBAAAAAAAAAAAAAAEAESExQVFhsf/aAAgBAQABPyHBdr8mYvwiV0o3Z8a5g+z6Wob6eCf/2gAMAwEAAgADAAAAEGgP/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPxA//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPxA//8QAHRABAQACAgMBAAAAAAAAAAAAAREAMUFRIXGRof/aAAgBAQABPxAmYczT9wQKLQun3lwG7XfzFydEHyOr1gFatYa8awWmqo7DP//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "linear pendants over open desk area",
            "title": "linear pendants over open desk area",
            "src": "/workplace-xg/static/71d0ffa2ed51f2093c41d540a55b8a98/2e753/linear-pendants-over-open-desk-area.jpg",
            "srcSet": ["/workplace-xg/static/71d0ffa2ed51f2093c41d540a55b8a98/69549/linear-pendants-over-open-desk-area.jpg 288w", "/workplace-xg/static/71d0ffa2ed51f2093c41d540a55b8a98/473e3/linear-pendants-over-open-desk-area.jpg 576w", "/workplace-xg/static/71d0ffa2ed51f2093c41d540a55b8a98/2e753/linear-pendants-over-open-desk-area.jpg 1152w", "/workplace-xg/static/71d0ffa2ed51f2093c41d540a55b8a98/a052a/linear-pendants-over-open-desk-area.jpg 1216w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">
  One hallmark of IBM interiors is linear lights used in open ceiling areas.
        </Caption>
      </Column>
      <Column colLg={8} colMd={5} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAMEAv/EABUBAQEAAAAAAAAAAAAAAAAAAAEC/9oADAMBAAIQAxAAAAHLJ2zTSsT/xAAZEAADAQEBAAAAAAAAAAAAAAAAAQIRAxP/2gAIAQEAAQUC85ZKeLlJIng8R//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8BP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8BP//EABsQAAICAwEAAAAAAAAAAAAAAAAhATECESJh/9oACAEBAAY/AuS0OSyMZ2/RH//EABoQAQADAQEBAAAAAAAAAAAAAAEAESFBcbH/2gAIAQEAAT8hBaPGYh9IwXa+QqgQnZragJSQn//aAAwDAQACAAMAAAAQmB//xAAWEQADAAAAAAAAAAAAAAAAAAAAARH/2gAIAQMBAT8QrKz/xAAWEQADAAAAAAAAAAAAAAAAAAAAARH/2gAIAQIBAT8QiIj/xAAdEAEAAgICAwAAAAAAAAAAAAABABEhMVGhYXGB/9oACAEBAAE/EAzf5E7jmpDVa3HwN2MQ8QrN5sRL+w8g1igX6hylcF66n//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "linear fixtures echo lines of wood slat ceiling",
            "title": "linear fixtures echo lines of wood slat ceiling",
            "src": "/workplace-xg/static/a80e09de193af4a84c71c90c9577fa64/2e753/linear-fixtures-echo-lines-of-wood-slat-ceiling.jpg",
            "srcSet": ["/workplace-xg/static/a80e09de193af4a84c71c90c9577fa64/69549/linear-fixtures-echo-lines-of-wood-slat-ceiling.jpg 288w", "/workplace-xg/static/a80e09de193af4a84c71c90c9577fa64/473e3/linear-fixtures-echo-lines-of-wood-slat-ceiling.jpg 576w", "/workplace-xg/static/a80e09de193af4a84c71c90c9577fa64/2e753/linear-fixtures-echo-lines-of-wood-slat-ceiling.jpg 1152w", "/workplace-xg/static/a80e09de193af4a84c71c90c9577fa64/a052a/linear-fixtures-echo-lines-of-wood-slat-ceiling.jpg 1216w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
      <Column colLg={4} colMd={3} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "133.33333333333331%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAbABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAMBAgQF/8QAFgEBAQEAAAAAAAAAAAAAAAAAAQAC/9oADAMBAAIQAxAAAAGFa4y8Q6ZTkMzpcsJ//8QAHBAAAgICAwAAAAAAAAAAAAAAAQIAIQMSETEy/9oACAEBAAEFArEZFyw4yCO3GzEkRjwqudjcfyLef//EABgRAAIDAAAAAAAAAAAAAAAAAAABEBEh/9oACAEDAQE/AbMHH//EABgRAAIDAAAAAAAAAAAAAAAAAAABEBEh/9oACAECAQE/AaNFH//EABsQAAMAAgMAAAAAAAAAAAAAAAABEQIQIUFR/9oACAEBAAY/AuFTzImlRdjKIe//xAAcEAADAQACAwAAAAAAAAAAAAAAAREhMVFBgaH/2gAIAQEAAT8hlGxk+EKnPYoOTJmGEwNjh4tSuj3Eq6M2xzeh+CvD6DJeh8n/2gAMAwEAAgADAAAAEGwv8f/EABgRAAIDAAAAAAAAAAAAAAAAAAARARBR/9oACAEDAQE/EGgYxX//xAAXEQEBAQEAAAAAAAAAAAAAAAAAEQFR/9oACAECAQE/EI1DpX//xAAeEAEAAgIDAAMAAAAAAAAAAAABESEAgTFBURBxsf/aAAgBAQABPxB4jsWGJ6yhIckjZ198YTMnpkVLBLcZBXCRN6S8jlQhIoeTkA4obwwdsCUiq1hyII6xvL1/cAC50+L/2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "cover lights",
            "title": "cover lights",
            "src": "/workplace-xg/static/06e7f9055df5e289ca4fd9eab34313ce/473e3/cove-lights.jpg",
            "srcSet": ["/workplace-xg/static/06e7f9055df5e289ca4fd9eab34313ce/69549/cove-lights.jpg 288w", "/workplace-xg/static/06e7f9055df5e289ca4fd9eab34313ce/473e3/cove-lights.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Cove lights provide architectural emphasis.</Caption>
      </Column>
      <Column colLg={4} colMd={3} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "133.33333333333331%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAbABQDASIAAhEBAxEB/8QAGQAAAwADAAAAAAAAAAAAAAAAAAMFAQIE/8QAFQEBAQAAAAAAAAAAAAAAAAAAAQD/2gAMAwEAAhADEAAAAVs6JRXBAm8m1gVDiv/EAB0QAAIBBAMAAAAAAAAAAAAAAAECAwAEERIQEzH/2gAIAQEAAQUCvGxU7noHjIrGaTIgbeKrfEkijQUFA4//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/AR//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAECAQE/AR//xAAfEAABBAEFAQAAAAAAAAAAAAABAAIQESESEyIxQYH/2gAIAQEABj8CaPqDhi45C1t1gFAmHamg+qh1GBH/xAAdEAEAAgICAwAAAAAAAAAAAAABABEhMRBBUWGR/9oACAEBAAE/IdL7i/a0OGZF9S3DjWY9IFb5H23UWibRMHQ14QCZcTrHH//aAAwDAQACAAMAAAAQy9bC/8QAFhEBAQEAAAAAAAAAAAAAAAAAEAEh/9oACAEDAQE/ECYf/8QAGBEAAwEBAAAAAAAAAAAAAAAAAAEhEEH/2gAIAQIBAT8Q7jsFD//EABsQAQEBAQEBAQEAAAAAAAAAAAERACExQVGh/9oACAEBAAE/EIhv6385NYuZ6FLLrS6of5hT4h1zJkLE6vgz1E1QnjMiJ8Lg/wBhNeK93rfKD5criCOSqw6E5+ZC+b//2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "modern graphic pendants",
            "title": "modern graphic pendants",
            "src": "/workplace-xg/static/4ce23595ebfe619662d7348ecbc5a7e4/473e3/modern-graphic-pendants.jpg",
            "srcSet": ["/workplace-xg/static/4ce23595ebfe619662d7348ecbc5a7e4/69549/modern-graphic-pendants.jpg 288w", "/workplace-xg/static/4ce23595ebfe619662d7348ecbc5a7e4/473e3/modern-graphic-pendants.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Choose modern, geometric pendants.</Caption>
      </Column>
      <Column colLg={8} colMd={5} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAIEAQP/xAAVAQEBAAAAAAAAAAAAAAAAAAABAv/aAAwDAQACEAMQAAAB2mdopDiJ/8QAGRAAAgMBAAAAAAAAAAAAAAAAAQIAAxES/9oACAEBAAEFAja06jjpjXscErtgP//EABURAQEAAAAAAAAAAAAAAAAAABAR/9oACAEDAQE/AYf/xAAVEQEBAAAAAAAAAAAAAAAAAAAQEf/aAAgBAgEBPwGn/8QAGxAAAgIDAQAAAAAAAAAAAAAAAAERIQISIjH/2gAIAQEABj8CVY+lo6bQuhascwf/xAAaEAACAwEBAAAAAAAAAAAAAAABEQAhMUFx/9oACAEBAAE/IWUE06YDOL92PShoATOIIuBgjek8mrrqf//aAAwDAQACAAMAAAAQy/8A/8QAFhEBAQEAAAAAAAAAAAAAAAAAAAEh/9oACAEDAQE/ELbH/8QAFhEBAQEAAAAAAAAAAAAAAAAAAQAR/9oACAECAQE/EAs7f//EAB0QAQACAgIDAAAAAAAAAAAAAAERIQAxQZFhcfH/2gAIAQEAAT8QPSA1bL61kRA4tzbVeMloIJxX1cQoEUR713hxgMytrMjkham64z//2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "linear fixtures form subtle ceiling grid pattern",
            "title": "linear fixtures form subtle ceiling grid pattern",
            "src": "/workplace-xg/static/53ebdfabe096e09008f7fa2f99a7e1bd/2e753/linear-fixtures-form-subtle-ceiling-grid-pattern.jpg",
            "srcSet": ["/workplace-xg/static/53ebdfabe096e09008f7fa2f99a7e1bd/69549/linear-fixtures-form-subtle-ceiling-grid-pattern.jpg 288w", "/workplace-xg/static/53ebdfabe096e09008f7fa2f99a7e1bd/473e3/linear-fixtures-form-subtle-ceiling-grid-pattern.jpg 576w", "/workplace-xg/static/53ebdfabe096e09008f7fa2f99a7e1bd/2e753/linear-fixtures-form-subtle-ceiling-grid-pattern.jpg 1152w", "/workplace-xg/static/53ebdfabe096e09008f7fa2f99a7e1bd/a052a/linear-fixtures-form-subtle-ceiling-grid-pattern.jpg 1216w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </ImageCollection>
    <h2>{`Zone lighting`}</h2>
    <p>{`Each zone serves a different purpose, and the lighting choices should reflect the purpose of the zone.`}</p>
    <h3>{`Welcome and connect`}</h3>
    <p><a parentName="p" {...{
        "href": "/workplace-xg/space-types/welcome"
      }}>{`Welcome`}</a>{` and `}<a parentName="p" {...{
        "href": "/workplace-xg/space-types/connect"
      }}>{`Connect`}</a>{` zone lighting should complement and integrate with the specialty ceiling elements in each zone. Whether linear or downlights, light should be lensed, soft and diffused.`}</p>
    <ImageCollection mdxType="ImageCollection">
      <Column colLg={8} colMd={5} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAwACBP/EABYBAQEBAAAAAAAAAAAAAAAAAAIAAf/aAAwDAQACEAMQAAABcWPLjtwf/8QAGRAAAwEBAQAAAAAAAAAAAAAAAAECEQMh/9oACAEBAAEFAq5e3BhVVVttj1H/xAAWEQADAAAAAAAAAAAAAAAAAAABEBH/2gAIAQMBAT8BFX//xAAWEQADAAAAAAAAAAAAAAAAAAABEBH/2gAIAQIBAT8BMX//xAAZEAADAAMAAAAAAAAAAAAAAAAAECEBETH/2gAIAQEABj8CIpiHNL//xAAaEAEAAwEBAQAAAAAAAAAAAAABABEhUUEx/9oACAEBAAE/IX1Wn2YYi+sKU99jSNHlPsSUz//aAAwDAQACAAMAAAAQt9//xAAXEQEBAQEAAAAAAAAAAAAAAAABABEh/9oACAEDAQE/EEHLt//EABcRAAMBAAAAAAAAAAAAAAAAAAABESH/2gAIAQIBAT8QSKYf/8QAHBABAQACAgMAAAAAAAAAAAAAAREAITFhQXGB/9oACAEBAAE/EErSA7aS4oNK+bxl26e8r5ipdkaTrART+pzMhC9jzn//2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "linear lights in a wood slat ceiling",
            "title": "linear lights in a wood slat ceiling",
            "src": "/workplace-xg/static/17931678a72c225e27f80c930ee2e38f/2e753/linear-lights-in-a-wood-slat-ceiling.jpg",
            "srcSet": ["/workplace-xg/static/17931678a72c225e27f80c930ee2e38f/69549/linear-lights-in-a-wood-slat-ceiling.jpg 288w", "/workplace-xg/static/17931678a72c225e27f80c930ee2e38f/473e3/linear-lights-in-a-wood-slat-ceiling.jpg 576w", "/workplace-xg/static/17931678a72c225e27f80c930ee2e38f/2e753/linear-lights-in-a-wood-slat-ceiling.jpg 1152w", "/workplace-xg/static/17931678a72c225e27f80c930ee2e38f/a052a/linear-lights-in-a-wood-slat-ceiling.jpg 1216w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">A walkway gets subtle definition with spot lighting.</Caption>
      </Column>
      <Column colLg={4} colMd={3} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAMEAv/EABYBAQEBAAAAAAAAAAAAAAAAAAEAAv/aAAwDAQACEAMQAAABNopyxjCf/8QAGRAAAwEBAQAAAAAAAAAAAAAAAAECEQMS/9oACAEBAAEFAo2To6NlD9IqUNc9/8QAFhEBAQEAAAAAAAAAAAAAAAAAABEh/9oACAEDAQE/AY1//8QAFhEBAQEAAAAAAAAAAAAAAAAAABEh/9oACAECAQE/Aax//8QAHhAAAQMEAwAAAAAAAAAAAAAAAAERMQIQEiFBYbH/2gAIAQEABj8CxRdeEz0MxHM23Sx//8QAHRABAAMAAQUAAAAAAAAAAAAAAQARITFBUWFxof/aAAgBAQABPyEo+vT4lRM9SahjOoAF5U1GVhnec9Lwz//aAAwDAQACAAMAAAAQV8//xAAXEQADAQAAAAAAAAAAAAAAAAAAAREh/9oACAEDAQE/EKbwg//EABcRAQEBAQAAAAAAAAAAAAAAAAEAESH/2gAIAQIBAT8QQHbZ/8QAHBABAAMBAQADAAAAAAAAAAAAAQARIUExUXGB/9oACAEBAAE/EDYLe5xel8hDA+GAHCnIHbDqhcv9ppEX7DlZL0bBAWRK+Yj1+bP/2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "natural light reception area",
            "title": "natural light reception area",
            "src": "/workplace-xg/static/e105423029e79827b5d54afec7b53c30/473e3/natural-light-reception-area.jpg",
            "srcSet": ["/workplace-xg/static/e105423029e79827b5d54afec7b53c30/69549/natural-light-reception-area.jpg 288w", "/workplace-xg/static/e105423029e79827b5d54afec7b53c30/473e3/natural-light-reception-area.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </ImageCollection>
    <h3>{`Play`}</h3>
    <p>{`The lighting in the `}<a parentName="p" {...{
        "href": "/workplace-xg/space-types/play"
      }}>{`Play`}</a>{` zone should complement and integrate with the specialty ceiling elements employed in this zone. A combination of lensed linear fixtures and downlights can be used. Decorative pendants should be suspended over the bar-height counter.`}</p>
    <ImageCollection mdxType="ImageCollection">
      <Column colLg={8} colMd={5} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAMFBP/EABUBAQEAAAAAAAAAAAAAAAAAAAEA/9oADAMBAAIQAxAAAAFKqChwFIj/xAAZEAACAwEAAAAAAAAAAAAAAAAAAQIDEhH/2gAIAQEAAQUCjGTXNDrbF2NeWOrR/8QAFREBAQAAAAAAAAAAAAAAAAAAECH/2gAIAQMBAT8Bp//EABURAQEAAAAAAAAAAAAAAAAAABAh/9oACAECAQE/AYf/xAAaEAADAQADAAAAAAAAAAAAAAAAAREhEkFx/9oACAEBAAY/ArxZhqInPC9lp//EABwQAQACAgMBAAAAAAAAAAAAAAEAESFRMUFxgf/aAAgBAQABPyGlHNmZRBmvRHrH6hKDULHGX3EdnP/aAAwDAQACAAMAAAAQkz//xAAVEQEBAAAAAAAAAAAAAAAAAAABEP/aAAgBAwEBPxAj/8QAFxEBAAMAAAAAAAAAAAAAAAAAAAEhUf/aAAgBAgEBPxCcKf/EABsQAQEAAwADAAAAAAAAAAAAAAERACExkaGx/9oACAEBAAE/EB8ZrAGriQnmCrg2pIcTzl40QAazu8QpQjSb+ZvvpymvWf/Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "large pendants over a counter",
            "title": "large pendants over a counter",
            "src": "/workplace-xg/static/0eb8efdcac142f5a1bb6d563ac59d5b7/2e753/large-pendants-over-a-counter.jpg",
            "srcSet": ["/workplace-xg/static/0eb8efdcac142f5a1bb6d563ac59d5b7/69549/large-pendants-over-a-counter.jpg 288w", "/workplace-xg/static/0eb8efdcac142f5a1bb6d563ac59d5b7/473e3/large-pendants-over-a-counter.jpg 576w", "/workplace-xg/static/0eb8efdcac142f5a1bb6d563ac59d5b7/2e753/large-pendants-over-a-counter.jpg 1152w", "/workplace-xg/static/0eb8efdcac142f5a1bb6d563ac59d5b7/a052a/large-pendants-over-a-counter.jpg 1216w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">
  Downlights provide low-profile general light, while pendants brighten the
  countertop.
        </Caption>
      </Column>
      <Column colLg={4} colMd={3} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAAAAME/8QAFQEBAQAAAAAAAAAAAAAAAAAAAQD/2gAMAwEAAhADEAAAAZaZzHUI/8QAGRAAAwEBAQAAAAAAAAAAAAAAAAECEwMi/9oACAEBAAEFAuni8qM2xWQ6ulLP/8QAFREBAQAAAAAAAAAAAAAAAAAAERD/2gAIAQMBAT8BCf/EABURAQEAAAAAAAAAAAAAAAAAABAR/9oACAECAQE/Aaf/xAAaEAACAgMAAAAAAAAAAAAAAAAAARExECEy/9oACAEBAAY/AobzdjTb0dSf/8QAHBABAAIDAAMAAAAAAAAAAAAAAQAhETFhUXGB/9oACAEBAAE/IQXnL4yTAhT9m8ocl6UdDGoAedagy/ck/9oADAMBAAIAAwAAABDj/wD/xAAWEQADAAAAAAAAAAAAAAAAAAABEEH/2gAIAQMBAT8QkV//xAAXEQEAAwAAAAAAAAAAAAAAAAABEBEh/9oACAECAQE/EG7kf//EABsQAQACAwEBAAAAAAAAAAAAAAERIQAxQVGR/9oACAEBAAE/EA0REXQGOYvhJN6fMijGNNGMCiV8Ts8xroIpNpV9vBpR1ZjP/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "open ceiling with bright task lighting over play space",
            "title": "open ceiling with bright task lighting over play space",
            "src": "/workplace-xg/static/449ec8ac6e34f747eb00b8895320e261/473e3/open-ceiling-with-bright-task-lighting-over-play-space.jpg",
            "srcSet": ["/workplace-xg/static/449ec8ac6e34f747eb00b8895320e261/69549/open-ceiling-with-bright-task-lighting-over-play-space.jpg 288w", "/workplace-xg/static/449ec8ac6e34f747eb00b8895320e261/473e3/open-ceiling-with-bright-task-lighting-over-play-space.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </ImageCollection>
    <h3>{`Collaborate`}</h3>
    <p>{`An open `}<a parentName="p" {...{
        "href": "/workplace-xg/space-types/collaborate"
      }}>{`Collaborate`}</a>{` zone can be differentiated by using a single, large, decorative pendant over the collaboration grouping. Differentiate a stand-up Collaborate zone with two or three small decorative pendants positioned over the stand-up table.`}</p>
    <ImageCollection mdxType="ImageCollection">
      <Column colLg={4} colMd={3} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAAAwAC/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAH/2gAMAwEAAhADEAAAAUHQwlR//8QAHBAAAQMFAAAAAAAAAAAAAAAAAQACEQMSISIy/9oACAEBAAEFAijEMGpVuKfP/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAHBAAAQMFAAAAAAAAAAAAAAAAAQAQMQIhIlFh/9oACAEBAAY/AgNwquWaUcm//8QAGhABAQADAQEAAAAAAAAAAAAAAREAITFBEP/aAAgBAQABPyEgNu5GM6mqsN2MKzwcxgmvefP/2gAMAwEAAgADAAAAEM8//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPxA//8QAFREBAQAAAAAAAAAAAAAAAAAAACH/2gAIAQIBAT8QV//EAB0QAQACAwADAQAAAAAAAAAAAAEAESExUUGBscH/2gAIAQEAAT8QQXNTqlz6JUBiRvbT3WZdEu+RQFFqh45G2AofNxLsmfwn/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "modern linear pendants",
            "title": "modern linear pendants",
            "src": "/workplace-xg/static/64fea42912d115cc70b224428a476e36/473e3/modern-linear-pendants.jpg",
            "srcSet": ["/workplace-xg/static/64fea42912d115cc70b224428a476e36/69549/modern-linear-pendants.jpg 288w", "/workplace-xg/static/64fea42912d115cc70b224428a476e36/473e3/modern-linear-pendants.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Linear lights define this relaxed seating area.</Caption>
      </Column>
      <Column colLg={8} colMd={5} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGAABAQEBAQAAAAAAAAAAAAAAAAMCBAX/xAAVAQEBAAAAAAAAAAAAAAAAAAACAf/aAAwDAQACEAMQAAABhbegpKEddQb5Qs//xAAaEAACAwEBAAAAAAAAAAAAAAABAgADERIT/9oACAEBAAEFAgsFYIFVjTDED57ZCvTkbGOt/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPwEf/8QAFhEAAwAAAAAAAAAAAAAAAAAAABAh/9oACAECAQE/ASP/xAAeEAABBAEFAAAAAAAAAAAAAAAAAQIRIQMQMVGh4f/aAAgBAQAGPwLg3ySeiorqK7KbrJ//xAAcEAEAAgIDAQAAAAAAAAAAAAABABEhMVFhcbH/2gAIAQEAAT8hv2ImaeAK+zL2tYzFnfA4l7ebpLPYTWpXEGlrjuOy3P/aAAwDAQACAAMAAAAQQOD/AP/EABcRAQADAAAAAAAAAAAAAAAAAAEAEBH/2gAIAQMBAT8QSa3/AP/EABcRAQADAAAAAAAAAAAAAAAAAAEAEBH/2gAIAQIBAT8QGZb/xAAdEAEBAAMAAgMAAAAAAAAAAAABEQAhMUGBUWGh/9oACAEBAAE/ENA7VVdh4MSacvIPr0wZ8UJjJT8c6p0R2yaxEIRBhaBO/OEul3QIgHPWCBEHBqYagxCRkIafBn//2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "large pendant over collaboration area",
            "title": "large pendant over collaboration area",
            "src": "/workplace-xg/static/fc4cf44dd1140fc5d3206b8d2568e7fb/2e753/large-pendant-over-collaboration-area.jpg",
            "srcSet": ["/workplace-xg/static/fc4cf44dd1140fc5d3206b8d2568e7fb/69549/large-pendant-over-collaboration-area.jpg 288w", "/workplace-xg/static/fc4cf44dd1140fc5d3206b8d2568e7fb/473e3/large-pendant-over-collaboration-area.jpg 576w", "/workplace-xg/static/fc4cf44dd1140fc5d3206b8d2568e7fb/2e753/large-pendant-over-collaboration-area.jpg 1152w", "/workplace-xg/static/fc4cf44dd1140fc5d3206b8d2568e7fb/a052a/large-pendant-over-collaboration-area.jpg 1216w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Choose pendants that suit each zone’s purpose.</Caption>
      </Column>
    </ImageCollection>
    <h3>{`Focus`}</h3>
    <p>{`The atmosphere of an enclosed meeting or `}<a parentName="p" {...{
        "href": "/workplace-xg/space-types/focus"
      }}>{`Focus`}</a>{` zone works best with a recessed, lensed linear fixture. The accent wall should be highlighted with a continuous lensed linear fixture.`}</p>
    <p>{`An open workplace Focus zone typically uses lensed linear fixtures. Fixture layout should be orderly, rhythmic and based on the 2x Grid. Variations in layout are permissible as long as foot-candle requirements are met at the work surface.`}</p>
    <p>{`If an open workplace Focus zone includes library tables, use two or three small, decorative pendants positioned over them.`}</p>
    <ImageCollection mdxType="ImageCollection">
      <Column colLg={8} colMd={5} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAMEAv/EABUBAQEAAAAAAAAAAAAAAAAAAAEA/9oADAMBAAIQAxAAAAFaa5ilNif/xAAbEAACAgMBAAAAAAAAAAAAAAAAAgETAxESIf/aAAgBAQABBQKrGzSnteyxVJeDo//EABURAQEAAAAAAAAAAAAAAAAAAAEQ/9oACAEDAQE/ASf/xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAcEAABAwUAAAAAAAAAAAAAAAAAAjFhARASISL/2gAIAQEABj8C4VjBWLaSMMf/xAAZEAADAQEBAAAAAAAAAAAAAAAAARExIdH/2gAIAQEAAT8hsNiNWlzRqTbD7OOC0fhE1oobtdJH/9oADAMBAAIAAwAAABCYH//EABURAQEAAAAAAAAAAAAAAAAAAAEQ/9oACAEDAQE/EFP/xAAVEQEBAAAAAAAAAAAAAAAAAAABEP/aAAgBAgEBPxBJ/8QAHhABAQABBAMBAAAAAAAAAAAAAREAITFBUWFxgZH/2gAIAQEAAT8QVQQaxrA7NAwy1TH6nzbHpSr28OsD9KbKxvL7xWlB3WEeJMbtD5sz/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "large pendants over table in focus area",
            "title": "large pendants over table in focus area",
            "src": "/workplace-xg/static/50bb911105ee157149888f7ad3bdd996/2e753/large-pendants-over-table-in-focus-area.jpg",
            "srcSet": ["/workplace-xg/static/50bb911105ee157149888f7ad3bdd996/69549/large-pendants-over-table-in-focus-area.jpg 288w", "/workplace-xg/static/50bb911105ee157149888f7ad3bdd996/473e3/large-pendants-over-table-in-focus-area.jpg 576w", "/workplace-xg/static/50bb911105ee157149888f7ad3bdd996/2e753/large-pendants-over-table-in-focus-area.jpg 1152w", "/workplace-xg/static/50bb911105ee157149888f7ad3bdd996/a052a/large-pendants-over-table-in-focus-area.jpg 1216w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
      <Column colLg={4} colMd={3} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "133.33333333333331%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAbABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAQFA//EABYBAQEBAAAAAAAAAAAAAAAAAAABAv/aAAwDAQACEAMQAAABqZz8IpC5E/Z11VRUy//EAB4QAAIBAwUAAAAAAAAAAAAAAAECAAMRIQQSEyIx/9oACAEBAAEFArw1BOWPUwKmFZLDtERiVVQunRdjeMc//8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPwEf/8QAFhEBAQEAAAAAAAAAAAAAAAAAABEB/9oACAECAQE/AUar/8QAHRAAAgEEAwAAAAAAAAAAAAAAAAEREBIhMSIykf/aAAgBAQAGPwKnUx4aNDtkbeBcZLozX//EABwQAQACAgMBAAAAAAAAAAAAAAEAESExQVGBcf/aAAgBAQABPyFJtg+b8jnhPsRToEDTbtbxKfC+cRIyXiWVWNBBBtrdwgH0mGHUZsrbP//aAAwDAQACAAMAAAAQJ/Cy/8QAFxEBAQEBAAAAAAAAAAAAAAAAABEBUf/aAAgBAwEBPxCrjOo//8QAFxEBAQEBAAAAAAAAAAAAAAAAABEBUf/aAAgBAgEBPxCarrUW/8QAHhABAQACAgIDAAAAAAAAAAAAAREAIXGhMVFh0fD/2gAIAQEAAT8QCoHLmjVwT3kkCe4x3YFEptLqeYefTiQqikr74gEBoMtxRZpVVOcA0kKJHn9rE3ALqr1gMRswRwTZ6wIkFVflz//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Linear lights",
            "title": "Linear lights",
            "src": "/workplace-xg/static/cf7f3010a23ad32691bb21e87c1a205c/473e3/linear-lights.jpg",
            "srcSet": ["/workplace-xg/static/cf7f3010a23ad32691bb21e87c1a205c/69549/linear-lights.jpg 288w", "/workplace-xg/static/cf7f3010a23ad32691bb21e87c1a205c/473e3/linear-lights.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Linear lights echo the ceiling grid.</Caption>
      </Column>
    </ImageCollection>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      